import React from 'react';
import { PACKAGES, getOfferPrice } from '../../Constants/Packages';
import { Button } from '../ui/Button';
import { getActiveOffer } from '../../Utils/OfferEngine';
import { FLASHOFFER } from '../../Constants/Const';
import { useBrand } from '../../Utils/BrandContext';

const StickyPricingFooter = ({ onBuyNow, onGetOffer, pageName = "" }) => {
    const { brand: activeBrand } = useBrand()
    const pkgId = pageName?.toLowerCase() == "gqik" ? 34 : 36;

    const silverEdition = PACKAGES[pkgId];
    const activeOffer = getActiveOffer();
    const flashOfferOn = activeOffer?.offerKey === 'FLASH_EOD';
    const sundayOfferOn = activeOffer?.offerKey === 'SUNDAY';
    const d3OfferOn = activeOffer?.offerKey === 'D3';
    const hasAnyOffer = !!activeOffer && activeOffer?.offerKey !== 'FRESH';
    const offerPrice = getOfferPrice(silverEdition, activeOffer);
    const handleBuyNow = () => {
        localStorage.removeItem("cpnYY2");
        onBuyNow?.(pkgId);
    };
    const handleGetOffer = (offerType) => {
        onGetOffer?.();
        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) { onBuyNow?.(pkgId); return; }
        const allData = JSON.parse(allDataRaw);
        const leadInfo = allData.info ? JSON.parse(allData.info) : [];
        localStorage.setItem("selEdn", pkgId);
        var couponCode = activeOffer?.couponCode || "";
        localStorage.setItem("selPrd", activeOffer?.planPeriod || "YY");
        localStorage.setItem("cpn", couponCode);
        localStorage.setItem("guidePG", window.location.pathname.substring(1));
        const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
        localStorage.setItem('cio', JSON.stringify(cioData));
        window.location.href = "/Html/External/BZPay.html";
    };
    if (!silverEdition) return null;

    return (
        <>
            <style>{`
        @keyframes flashBlink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
        .flash-blink { animation: flashBlink linear 3s infinite; }
      `}</style>

            {/* Mobile Only - Sticky Bottom Footer */}
            <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#f0f1f3] shadow-[0_-4px_24px_rgba(0,0,0,0.2)] px-3 py-3">

                {/* No Offer Layout */}
                {!hasAnyOffer && (
                    <div
                        className="flex items-center justify-between gap-3"
                        onClick={handleBuyNow}
                    >
                        <div>
                            <p className="text-xs text-red-500 font-medium leading-tight mb-0.5 pl-4">Start @ just</p>
                            <div className="flex items-baseline gap-1 flex-nowrap">
                                <span className="text-[20px] font-light text-text-secondary">₹</span>
                                <span className="text-[30px] font-semibold text-text-primary leading-none">
                                    {silverEdition.baseAmtStr}
                                </span>
                                {silverEdition.stdAmt && silverEdition.stdAmt > silverEdition.baseAmt && (
                                    <s className="text-[13px] text-gray-500 font-medium whitespace-nowrap">
                                        ₹ {silverEdition.stdAmtStr}
                                    </s>
                                )}
                                <span className="text-[11px] text-text-secondary whitespace-nowrap pl-1">/ year +GST</span>
                            </div>
                        </div>
                        <Button
                            onClick={(e) => { e.stopPropagation(); handleBuyNow(); }}
                            variant="primaryDarkBlue"
                            size="sm"
                            className="shrink-0"
                        >
                            Buy Now
                        </Button>
                    </div>
                )}

                {/* Common Offer Layout — works for all offer types */}
                {hasAnyOffer && (
                    <div
                        className="flex items-center justify-between gap-3"
                        onClick={() => handleGetOffer('any')}
                    >
                        <div>
                            <p className="text-[14px] text-red-500 font-medium leading-tight mb-1">Extra {Math.round((1 - Number(offerPrice.displayPrice.replace(/,/g, '')) / Number(offerPrice.stdPrice.replace(/,/g, ''))) * 100)}% Off on 1st year</p>
                            <div className="flex items-baseline gap-1 flex-nowrap">
                                <s className="text-[13px] text-text-secondary font-medium whitespace-nowrap">
                                    ₹ {offerPrice.stdPrice}
                                </s>
                                <span className="text-[20px] font-light text-text-secondary">₹</span>
                                <span className="text-[30px] font-semibold text-text-primary leading-none">
                                    {offerPrice.displayPrice}
                                </span>
                                <span className="text-[11px] text-text-secondary whitespace-nowrap pl-1"> +GST</span>
                            </div>
                            <p className="text-xs text-red-500 font-medium leading-tight mt-0.5 flash-blink">
                                {activeOffer?.label} Ending Soon!
                            </p>
                        </div>
                        <Button
                            onClick={(e) => { e.stopPropagation(); handleGetOffer('any'); }}
                            variant="primaryDarkBlue"
                            size="sm"
                            className="shrink-0 !py-2 !px-2 text-base"
                        >
                            Buy Now
                        </Button>
                    </div>
                )}

            </div>

            {/* Spacer so content isn't hidden behind sticky footer on mobile */}
            <div className="md:hidden h-[80px]" />
        </>
    );
};

export default StickyPricingFooter;